import React from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'clsx';
import { Collapse } from '@linktivity/link-ui';
import { ReactMarkdown } from '@link/share/components';
import { type FAQItemProps } from './FAQItem.types';
import styles from './faqItem.module.css';

const { Panel } = Collapse;

const FAQItem: React.FC<FAQItemProps> = ({
  items,
  translateItems = false,
  sectionKey = '',
  className,
  panelClassName,
  answerClassName
}) => {
  const { t } = useTranslation();

  const renderQuestion = (text: string = '') =>
    translateItems ? t(text) : text;
  const renderAnswer = (text: string = '') => (translateItems ? t(text) : text);

  return (
    <Collapse accordion className={cls(styles.collapse, className)}>
      {items.map((item, index) => (
        <Panel
          className={cls(styles.panel, panelClassName)}
          key={`${sectionKey}-${index}`}
          header={renderQuestion(item.question ?? '')}
        >
          <div className={cls(styles.answer, answerClassName)}>
            <ReactMarkdown source={renderAnswer(item.answer ?? '')} />
          </div>
        </Panel>
      ))}
    </Collapse>
  );
};

export default FAQItem;
